<script lang="ts">
    import NavigationButton from "../shared/NavigationButton.svelte";
</script>
<svelte:head>
    <title>Roses UPC - Rosa no trobada</title>
</svelte:head>

<p>
    Aquesta rosa no s'ha trobat, ni tampoc és a la cua perquè es generi.
    <br>
    Ves a la pàgina principal si en vols generar una de nova o a la galeria si vols veure les que ja hi ha creades.
</p>

<div class="row-buttons">
    <NavigationButton to="/" text="Anar a la Pàgina Principal"></NavigationButton>
    <NavigationButton to="galeria" text="Anar a la Galeria"></NavigationButton>
</div>
